import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const recommendation_options:SchemaTableOptions = {
    name:<string> 'recommendation_options',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'value', value: 'VARCHAR(255) NOT NULL'},
        { column: 'label', value: 'VARCHAR(255) NOT NULL'},
    ]
}